module.exports = __webpack_public_path__ + "static/img/rddExpenseTax_2_1_h5.7b341ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/rddExpenseTax/rddExpenseTax_2_1_h5.png
// module id = WoN0
// module chunks = 34